<template>
  <form @submit.prevent="submitForm" id='RecieveTransfer'>

    <div class="mb-3">
      <!--<label for="input-sku" class="form-label">
        Select Transfer to Receive
      </label>
      <select v-model="transferToReceive" class="form-control" id="input-transfer-to-receive">
        <option v-for="(transferId, index) in transferToReceiveList" :value="transferId.value" :selected="index == 0" :change='importTransferData'>
          {{ transferId.label }}
        </option>
      </select> -->
      <Select
            label='Select Transfer to Receive'
            store='PowerScan'
            name='selectedTransfer'
            :options='transferToReceiveList'
            @validate-field='importTransferData'
        />
    </div>

    <div class="mb-3">
      <label for="input-sku" class="form-label">
        Enter SKU
      </label>
      <input ref='skuInput' type="text" v-model="sku" class="form-control" id="input-receive-sku" @keyup="validateSku">
      <span class='scanError' v-if="scanError != ''">{{scanError}}</span>
    </div>

    <div class="mb-3">

      <div class="row">
        <div class="col-6">
          <label class="form-label">
            Received SKUs
          </label>
        </div>
        <div class="col-6 text-right">
          <label class="form-label">
            Total: {{ scannedSkus.length }} Products
          </label>
        </div>
      </div>

      <ul class="list-group">
        <li :class="selectedSkus.includes(item) ? 'list-group-item active' : 'list-group-item'" v-for="(item, index) in scannedSkus">
          <div class="row">
            <div class="col-8 align-self-center" @click="selectSku(item)">
              {{ item.sku }}
            </div>
            <div class="col-4 text-right">
              <button type="button" class="btn btn-default btn-sm">
                View More
              </button>
            </div>
          </div>
        </li>
        <li class="list-group-item" v-if="scannedSkus.length == 0">
          Nothing scanned yet
        </li>
      </ul>
    </div>

    <div class="row mb-3">
      <div class="col-6">
        <button type="button" class="btn btn-secondary btn-sm btn-clear-selected" @click.prevent="clearSelected" :disabled="!scannedSkus.length">
          Clear Selected
        </button>
      </div>
      <div class="col-6 text-right">
        <button type="button" class="btn btn-primary btn-sm btn-clear-all" @click.prevent="clearAll" :disabled="!scannedSkus.length">
          Clear All
        </button>
      </div>
    </div>

    <div class="mb-3">
      <label for="input-sku" class="form-label">
        Select Destination for Transfer
      </label>
       <input ref='skuInput' type="text" placeholder='Scan a Destination Bin' v-model="toBin" class="form-control" id="input-receive-bin" @keyup="setBin">
       <span :class="{'validated':destinationValid}" class='scannedBinError' v-if="scannedBinError != ''">{{scannedBinError}}</span>
      <!--<select v-model="destinationForTransfer" class="form-control" id="input-transfer-to-receive">
        <option v-for="(transferId, index) in transferToReceiveList" :value="transferId" :selected="0 == index">
          {{ transferId }}
        </option>
      </select>-->
    </div>

    <div class="d-grid gap-2 col-sm-6 mx-auto mt-4">
      <button type="button" class="btn btn-success w-100 btn-finalize-receipt" :disabled='finalizeDisabled' @click='recieveTransfer'>
        Finalize Receipt
      </button>
    </div>

  </form>
</template>

<script>
  import Select from '../../../form/Select.vue';
  export default {
    name: 'ReceiveTransfer',
    components:{
        Select
    },
    data() {
      return {
        sku : '',
        transferToReceive : '',
        destinationForTransfer : [],
        scannedSkus : [],
        selectedSkus : [],
        scanError : '',
        toBin: '',
        toLocId: '',
        toLocNum: '',
        scannedBinError: '',
        division: this.$store.getters['PowerScan/division'],
        destinationValid: false
      }
    },
    mounted() {
      this.myToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      this.$refs.skuInput.focus();
      this.$store.dispatch('PowerScan/fetchOpenTransfers');
    },
    computed:{
        transferToReceiveList(){
            return this.$store.getters['PowerScan/siteOpenTransfers']
        },
        selectedTransferId(){
            return this.$store.getters['PowerScan/selectedTransfer']
        },
        itemsInSelectedTransfer(){
            return this.$store.getters['PowerScan/itemsInCurrentTransfer']
        },
        selectedSite(){
            return this.$store.getters['PowerScan/selectedSite'];
        },
        finalizeDisabled(){
            return this.scannedSkus == 0 || !this.destinationValid
        }
    },
   /* watch:{
        scannedSkus: function(oldValue, newValue){
            //console.log('scannedSkus being changed: ', newValue)
        }
    },*/
    methods: {
      importTransferData(){
          this.scannedSkus = [];
          this.selectedSkus = [];
          this.$store.dispatch('PowerScan/fetchItemsInTransfer', this.selectedTransferId)
      },
      clearSelected() {
        this.selectedSkus.forEach(sku => this.removeSku(sku))
        this.selectedSkus.splice(0, this.selectedSkus.length)
      },
      clearAll() {
        this.selectedSkus.splice(0, this.selectedSkus.length)
        this.scannedSkus.splice(0, this.scannedSkus.length)
      },
      selectSku(item) {
        //console.log('selecting - '+item.sku)

        if ( this.selectedSkus.includes(item) ) {
          this.selectedSkus.splice(this.selectedSkus.indexOf(item), 1)
        } else {
          this.selectedSkus.push(item)
        }
      },
      removeSku(sku) {
        this.scannedSkus.splice(this.scannedSkus.indexOf(sku), 1)
      },
      addSku(sku) {
        if ( sku ) {
          if ( this.scannedSkus.indexOf(sku) == -1 ) { 
            this.scannedSkus.push(sku)
          }
        }
      },
      async setBin(e){
          let enter = ( 'Enter' == e.key ? '' : '' )
          this.destinationValid = false;
            if ( 'Enter' == e.key ) {
                this.scannedBinError = '';
                if(this.toBin.indexOf('_') == -1){
                    this.scannedBinError = 'Invalid Bin Format'
                }else{
                    let binCheck = await this.$store.dispatch('PowerScan/fetchLocationValidation', this.toBin)
                    .then((response)=>{
                        //console.log('returning with a response 1 : ', response)
                        if (response['valid']){
                            //console.log('valid bin! - ', this.toBin)
                            let splitBin = this.toBin.split('_');
                            this.toLocId = splitBin[0];
                            this.toLocNum = splitBin[1];
                            this.destinationValid = true;
                            this.scannedBinError = 'Bin Ready For Transfer'
                        }else{
                            this.scannedBinError = response['message'];
                        }
                    });
                }
            }
      },
      recieveTransfer(){
          //console.log('recieveTransfer')
          if (this.selectedSkus.length > 0){
          }else{
            this.scannedSkus.forEach((item) =>{
                console.log('item - '+ JSON.stringify(item))
                let payload = {
                        id: item.id,
                        name:'InventoryTransfer',
                        req_ref: Math.random().toFixed(10),
                        api_token: 'token',
                        params: {   
                            item: item.sku,
                            type: 'INVLOCLOC',
                            quantity: item.qty,
                            from_div: this.division,
                            from_site: this.selectedSite.Id,
                            to_div: this.division,
                            to_site: this.selectedSite.Id,
                            from_locid: `${this.division}_${this.selectedSite.value}_${this.selectedSite.inTransitLocId}`,
                            to_locid: `${this.division}_${this.selectedSite.value}_${this.toLocId}`,
                            from_proj: item.proj,
                            to_proj: item.proj,
                            from_locnum: 'TRUCK',
                            to_locnum: this.toLocNum,
                            Managed_Transfer_Line__c: item.id, // WHERE Id is the Id of the managed Transfer from the openTransfers call
                        },
                        product: item
                    }
                this.$store.dispatch('PowerScan/transferInventory', payload);
            });
          }
      },
      async validateSku(e) {
        let enter = ( 'Enter' == e.key ? '' : '' )
        if ( 'Enter' == e.key ) {
          e.preventDefault()
          this.scanError = '';
          let itemIndexInTransfer = this.itemsInSelectedTransfer.findIndex(x => x.sku == this.sku);
          if (itemIndexInTransfer != -1){
              if ((this.itemsInSelectedTransfer[itemIndexInTransfer].qtySent - this.itemsInSelectedTransfer[itemIndexInTransfer].qtyReceived) <= 0){
                  this.scanError = 'Item already received for this transfer'
              }else{
                let myFoundItem = this.$store.dispatch('ItemCard/fetchSimpleItemInfo', {sku: this.sku, store: 'PowerScan'})
                .then((response) => {
                    //console.log( 'founditem '+this.sku+' response - ' + JSON.stringify(response));
                    let tempItem = {
                        id: this.itemsInSelectedTransfer[itemIndexInTransfer].id,
                        proj: this.itemsInSelectedTransfer[itemIndexInTransfer].proj,
                        qty: this.itemsInSelectedTransfer[itemIndexInTransfer].qty,
                        qtyReceived: this.itemsInSelectedTransfer[itemIndexInTransfer].qtyReceived,
                        qtySent: this.itemsInSelectedTransfer[itemIndexInTransfer].qtySent,
                        sku: this.itemsInSelectedTransfer[itemIndexInTransfer].sku,
                        image: response[this.itemsInSelectedTransfer[itemIndexInTransfer].sku].Image_URL__c
                    }
                    this.addSku(tempItem);
                });
                
                //console.log('sku found!!! - ')
              }
          }else{
              this.scanError = 'Item not in this Transfer'
              //console.log('nope!!!');
          }
          this.sku = ''
        }
      },
      
      submitForm() {
        const {
          sku,
          transferToReceive,
          destinationForTransfer,
          scannedSkus
        } = this
       // console.log('ReceiveTransfer', scannedSkus, transferToReceive, destinationForTransfer)
      }
    }
  }
</script>
